import React from 'react';
import {constants} from '@neosvoc/nv-platform-core-common';
import {injectIntl} from 'react-intl';
import messages from '../../../../../../res/translations/messages';
import Operator from '../Operator';
import QuestionId from '../QuestionId';
import DateValue from '../DateValue';

class DateBuilder extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {expression, intl} = this.props;

        let operator;
        switch (expression.condition.operator) {
            case constants.EDITOR_OPERATORS.GT:
                operator = intl.formatMessage({...messages.filters.operators.greaterThan});
                break;
            case constants.EDITOR_OPERATORS.LT:
                operator = intl.formatMessage({...messages.filters.operators.lessThan});
                break;
        }

        if (!operator) {
            return null;
        }

        return (
            <>
                <QuestionId id={expression.id} />
                <Operator operator={operator} />
                <DateValue value={expression.condition.value} />
            </>
        );
    }
}

export default injectIntl(DateBuilder);
